import { FC, ReactNode } from 'react';
import { Store } from '@reduxjs/toolkit';
import { createUiKitTheme } from 'team-hero-ui';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';

import GlobalStyle from 'assets/styles/GlobalStyles';

interface IProvidersProps {
  children: ReactNode;
  store: Store;
}

const theme = createUiKitTheme();

const ProvidersWithoutRouter: FC<IProvidersProps> = ({ children, store }) => (
  <Provider store={store}>
    <GlobalStyle />
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </Provider>
);

export default ProvidersWithoutRouter;
